@if (form) {
  <form [formGroup]="form">
    <div class="modal-body">
      <div class="row">
        @if (!isMainAddress) {
          <div class="d-flex flex-row align-items-center flex-wrap col-12">
            <div class="d-flex flex-row align-items-center flex-wrap mb-3 text-secondary col-12 col-lg-4">
              <label class="required">Nom</label>
              <input type="text" class="form-control" formControlName="name" [class.is-invalid]="submitted && form.controls?.name?.errors?.required" />
              @if (submitted && form.controls?.name?.errors?.required) {
                <small class="form-text text-danger">Le nom est requis.</small>
              }
            </div>
            <div class="d-flex flex-row align-items-center justify-content-center flex-wrap text-secondary col-12 col-lg-4">
              <div class="form-check form-switch">
                <input id="structureActive" class="form-check-input" type="checkbox" formControlName="active" />
                <label class="form-check-label" for="structureActive">Active</label>
              </div>
            </div>
            <div class="d-flex flex-row align-items-center justify-content-center flex-wrap text-secondary col-12 col-lg-4">
              <div class="form-check form-switch">
                <input id="structurePortalVisibility" class="form-check-input" type="checkbox" formControlName="publicReception" />
                <label class="form-check-label" for="structurePortalVisibility">Site accueillant le public</label>
              </div>
            </div>
          </div>
        }
        <div class="mb-3 text-secondary col-8">
          @if (isMainAddress) {
            <label class="required">Adresse principale</label>
          }
          @if (!isMainAddress) {
            <label class="required">Adresse</label>
          }
          <input
            #input
            type="text"
            class="form-control"
            autocomplete="ooff"
            formControlName="address"
            [ngbTypeahead]="search"
            [inputFormatter]="inputFormat"
            [resultFormatter]="resultFormat"
            [editable]="false"
            (selectItem)="onSelectItem($event)"
            (blur)="onBlur(input)"
            [class.is-invalid]="submitted && form.controls?.address.errors?.required"
            />
          @if (submitted && form.controls?.address.errors?.required) {
            <small class="form-text text-danger"
              >L'adresse de la structure est requise.</small
              >
            }
            @if (submitted && form.controls?.geoJSON.errors?.required) {
              <small class="form-text text-danger"
                >Veuillez sélectionner une adresse depuis la liste de suggestions</small
                >
              }
            </div>
            <div class="mb-3 text-secondary col-4">
              <label>Complément d'adresse</label>
              <input
                type="text"
                class="form-control"
                formControlName="additionalAddress"
                [class.is-invalid]="submitted && form.controls?.additionalAddress.errors?.pattern"
                />
              @if (submitted && form.controls?.additionalAddress?.errors?.pattern) {
                <small class="form-text text-danger"
                  >Le complément d'adresse de la structure n'est pas valide.</small
                  >
                }
              </div>
              <div class="mb-3 text-secondary col-12 col-lg-2 col-xl-2">
                <label class="required">Code postal</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="postalCode"
                  maxlength="5"
                  [class.is-invalid]="submitted && (form.controls?.postalCode?.errors?.pattern || form.controls?.postalCode?.errors?.required)"
                  />
                @if (submitted && form.controls?.postalCode?.errors?.required) {
                  <small class="form-text text-danger"
                    >Le code postal de la structure est requis.</small
                    >
                  }
                  @if (submitted && form.controls?.postalCode?.errors?.pattern) {
                    <small class="form-text text-danger">
                      Le code postal doit être composé de 5 chiffres
                    </small>
                  }
                </div>
                <div class="mb-3 text-secondary col-12 col-lg-6 col-xl-6">
                  <label class="required">Ville</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="city"
                    [class.is-invalid]="submitted && (form.controls?.city?.errors?.required || form.controls?.city?.errors?.pattern)"
                    />
                  @if (submitted && form.controls?.city?.errors?.required) {
                    <small class="form-text text-danger">La ville de la structure est requise.</small>
                  }
                  @if (submitted && form.controls?.city?.errors?.pattern) {
                    <small class="form-text text-danger"
                      >La ville de la structure n'est pas valide.</small
                      >
                    }
                  </div>
                  <div class="mb-3 text-secondary col-12 col-lg-4">
                    <label>Numéro de téléphone</label>
                    <input
                      type="tel"
                      class="form-control"
                      formControlName="phone"
                      maxlength="10"
                      [class.is-invalid]="submitted && form.controls?.phone?.errors?.pattern"
                      />
                    @if (submitted && form.controls?.phone?.errors?.pattern) {
                      <small class="form-text text-danger"
                        >Le numéro de téléphone doit être composé de 10 chiffres.</small
                        >
                      }
                    </div>
                    @if (isMainAddress) {
                      <div class="d-flex flex-row align-items-center flex-wrap text-secondary ms-auto me-2">
                        <div class="form-check form-switch">
                          <input id="structureActive" class="form-check-input" type="checkbox" formControlName="publicReception" />
                          <label class="form-check-label" for="structureActive">Site accueillant le public</label>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </form>
            }
